<template>
  <div>
    <loading v-show="loading"></loading>
    <div class="poor-layout">
      <poor-item v-for="(item,index) in poorInfo" :key="index" :data="item" :index="index"></poor-item>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';
  import loading from '@/components/common/loading.vue';
  import poorItem from './poorItem';

  export default {
    components: { loading, poorItem },
    data() {
      return {
        poorInfo: [],
        loading: false
      };
    },
    methods: {
      calcGestureState() {
        setTimeout(() => {
          const layout = document.querySelector('.poor-layout');
          if (layout) {
            this.$store.commit('changeGestureState', layout.scrollWidth > layout.offsetWidth);
          }
        }, 500);
      },
      async loadPoorInfo() {
        const resultData = JSON.parse(localStorage.getItem('resultData'));
        const { CorpID, ProductBatchID } = resultData || {};
        if (CorpID && ProductBatchID) {
          this.loading = true;
          const result = await this.$ajax.jsonp(this.$urlAPI.BaseData.GetPoorInfo, { CorpID, ProductBatchID });
          this.loading = false;
          const poorInfo = _.get(result, 'Data.PoorList');
          if (Array.isArray(poorInfo)) {
            this.poorInfo = poorInfo;
            this.calcGestureState();
          }
        }
      },
    },
    mounted() {
      this.$store.commit('setPageTitle', '扶贫信息');
      this.$store.commit('changeGestureState', false);
      this.loadPoorInfo();
    }
  }
</script>

<style scoped>
  .poor-layout {
    position: absolute;
    left: 0;
    right: 0;
    padding: 0 50px;
    top: 0.3rem;
    bottom: 0.3rem;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// index.vue?850cca84